import { axiosIns } from '@axios'
import { QueryTypes } from '@/store/core/actions'
import { i18n } from '@/plugins/i18n'

export const getCandidateEntries = async ({ dispatch }, { tags, gdprStatus, search, page, pageSize, ordering }) => {
  const { data, success } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.GET,
      url: `company/talent-pool/entries/`,
      params: {
        candidate__tags: tags,
        gdpr_status: gdprStatus,
        search,
        page,
        page_size: pageSize,
        ordering,
      },
    },
    {
      root: true,
    },
  )

  return { data, success }
}

export const getCandidatesOverview = async ({ dispatch }) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.GET,
      url: `company/talent-pool/entries/overview/`,
    },
    { root: true },
  )

  return data
}

export const getCandidateEntryDetails = async ({ dispatch, commit }, payload) => {
  const { candidateEntryId, navigationParams } =
    typeof payload === 'string' || typeof payload === 'number'
      ? { candidateEntryId: payload, navigationParams: undefined }
      : payload

  const { success, data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.GET,
      url: `company/talent-pool/entry/${candidateEntryId}/`,
      params: navigationParams,
    },
    { root: true },
  )
  if (success) commit('SET_CANDIDATE_ENTRY_DATA', data)

  return { success, data }
}

export const updateCandidateEntryDetails = async ({ dispatch, commit }, { id, payload }) => {
  const { data, success } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.PATCH,
      url: `company/talent-pool/entry/${id}/`,
      payload,
    },
    { root: true },
  )
  if (success) commit('SET_CANDIDATE_ENTRY_DATA', data)

  return { data, success }
}

export const candidateEntryAutoAnonymizationDisabled = async ({ dispatch }, candidateId) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/talent-pool/entry/${candidateId}/withheld-from-deletion/`,
    },
    { root: true },
  )

  return data
}

export const candidateEntrySetForAnonymization = async ({ dispatch }, candidateId) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/talent-pool/entry/${candidateId}/set-for-deletion/`,
    },
    { root: true },
  )

  // TODO: true / false
  return !!data
}

export const candidateAcceptAnonymizationRequest = async ({ dispatch }, candidateId) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/talent-pool/entry/${candidateId}/accept-delete-request/`,
    },
    { root: true },
  )

  return data
}

export const candidateDeclineAnonymizationRequest = async ({ dispatch }, candidateId) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/talent-pool/entry/${candidateId}/decline-delete-request/`,
    },
    { root: true },
  )

  return data
}

export const getCandidateFilterChoices = async ({ dispatch }, { tags, gdprStatus, search }) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.GET,
      url: `company/talent-pool/filter-choices/`,
      params: {
        candidate__tags: tags,
        gdpr_status: gdprStatus,
        search,
      },
    },
    { root: true },
  )

  return data
}

export const renewCandidateConsent = async ({ dispatch }, candidateId) => {
  const { data } = await dispatch('axiosQueryBuilder', {
    type: QueryTypes.POST,
    url: `company/talent-pool/entry/${candidateId}/renew-consent/`,
  })

  // TODO: true / false
  return !!data
}

export const signUpForCandidates = async ({ dispatch }, payload) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/talent-pool/sign-up/`,
      payload,
    },
    { root: true },
  )

  // TODO: true / false
  return !!data
}

export const getInviteCandidatesUrl = async ({ dispatch }, { lang, invitedBy }) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.GET,
      url: `company/talent-pool/invite/link/`,
      params: {
        lang,
        invited_by: invitedBy,
      },
    },
    { root: true },
  )

  return data.inviteTalentPoolUrl
}

export const sendInvitationToJob = async ({ dispatch }, { candidateId, payload }) => {
  const { data } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/talent-pool/entry/${candidateId}/send-invitation-to-job/`,
      payload,
    },
    { root: true },
  )

  // TODO: true / false
  return !!data
}

const inviteToJob = async ({ dispatch }, { jobId, payload }) => {
  await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.POST,
      url: `company/offer/${jobId}/invite/`,
      payload,
    },
    { root: true },
  )
}

// eslint-disable-next-line camelcase
export const exportCandidateEntries = async ({ commit }, { fields, column_names, stage }) => {
  try {
    const response = await axiosIns.get(`company/talent-pool/entries/export/`, {
      params: { fields, column_names, stage },
    })

    return {
      success: true,
      data: response.data,
      fileName: response.headers['content-disposition'].split('filename=')[1].split(';')[0],
    }
  } catch (e) {
    commit('app/SET_ERROR_SNACK', i18n.t('somethingWentWrong'), {
      root: true,
    })
    console.error(e)

    return { success: false }
  }
}

export const deleteCandidateEntryInternalNote = async ({ dispatch }, internalNoteId) => {
  const { success } = await dispatch(
    'core/axiosQueryBuilder',
    {
      type: QueryTypes.DELETE,
      url: `company/talent-pool/entry/internal-note/${internalNoteId}/`,
    },
    { root: true },
  )

  return { success }
}

export default {
  getCandidateEntries,
  getCandidatesOverview,
  getCandidateEntryDetails,
  updateCandidateEntryDetails,
  candidateEntryAutoAnonymizationDisabled,
  candidateEntrySetForAnonymization,
  candidateAcceptAnonymizationRequest,
  candidateDeclineAnonymizationRequest,
  getCandidateFilterChoices,
  renewCandidateConsent,
  signUpForCandidates,
  getInviteCandidatesUrl,
  sendInvitationToJob,
  inviteToJob,
  exportCandidateEntries,

  deleteCandidateEntryInternalNote,
}
